// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_BuscaFranquiaIdPorWhatsappAtendimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/devices_franquias/busca_franquia_id_por_whatsapp_atendimento/{numero}
 *
 * Resolves the franquia associated with a device's WhatsApp number. The model
 * (devices_franquias_model::busca_por_numero_whatsapp) returns the single
 * FranquiaOutput object produced by franquias_model::buscaFranquia — the same
 * {Franquia, AreasAtuacao} shape served by /franquias/buscaFranquia/{id}, so
 * the row shape is reused via Franquias_BuscaFranquiaRow.
 */
import type { Franquias_BuscaFranquiaRow } from './Franquias_BuscaFranquiaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DevicesFranquias_BuscaFranquiaIdPorWhatsappAtendimentoResponseDados = Franquias_BuscaFranquiaRow;

export type DevicesFranquias_BuscaFranquiaIdPorWhatsappAtendimentoResponse = ApiResponse<DevicesFranquias_BuscaFranquiaIdPorWhatsappAtendimentoResponseDados>;

registerResponseContract('DevicesFranquias_BuscaFranquiaIdPorWhatsappAtendimentoResponse', {
  _nullable:    { type: 'boolean', required: false },
  Franquia: {
    type: 'object',
    required: false,
    fields: {
      ID:        { type: 'number',  required: false },
      Nome:      { type: 'string',  required: false },
      Email:     { type: 'string',  required: false },
      CNPJ:      { type: 'string',  required: false },
      Pais:      { type: 'string',  required: false },
      Idioma:    { type: 'string',  required: false },
      CreatedAt: { type: 'string',  required: false },
      UpdatedAt: { type: 'string',  required: false },
      DeletedAt: { type: 'string',  required: false },
      Ativo:     { type: 'boolean', required: false },
    },
  },
  AreasAtuacao: { type: 'object',  required: true },
})
